import validateDateTime from './validateDateTime'

export default validateDateTime
